import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { firstValueFrom } from 'rxjs';

import { handleHttpError } from '../../helpers/handleHttpError';
import { ApiRemoteUpdate } from '../../infrastructure/services/api-remote-update';
import { BackendVersionStoreType } from '../../infrastructure/types/backend-version.type';

const initialState: BackendVersionStoreType = {
  backendVersion: { data: null, loading: false, error: null }
};

export const useBackendVersionStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(store => {
    const api = inject(ApiRemoteUpdate);

    return {
      async loadBackendVersion() {
        patchState(store, state => ({
          backendVersion: { ...state.backendVersion, loading: true }
        }));

        try {
          const data = await firstValueFrom(api.get<{ version: string }>('/version'));
          patchState(store, state => ({
            backendVersion: {
              ...state.backendVersion,
              data,
              loading: false,
              error: null
            }
          }));
        } catch (error) {
          patchState(store, state => ({
            backendVersion: {
              ...state.backendVersion,
              loading: false,
              error: handleHttpError(error, 'Failed to load the backend version')
            }
          }));
        }
      }
    };
  })
);
